<!-- Start Content-->
<div class="container-fluid">
    <div class="row my-1">
        <div class="col-md-12">
            <div class="userTables">

                <div class="row">
                    <div class="col-12">
                        <!-- <h2>{{router.url.includes('settlement') ? 'settlement' : 'balance sheet'}}</h2> -->
                        <accordion class="theme_accordion" [closeOthers]="true" *ngIf="data">
                            <accordion-group [isOpen]="i == 0" *ngFor="let item of data?.user_configs;let i=index;trackBy:trackByIndex;">
                                <button class="btn btn-link" accordion-heading type="button">
                                    Casino ({{item?.market_type_id}}) hh
                                </button>
                        
                                <form id="" class="admin_form" action="" method="post">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Min Bet:</label>
                                                <input type="number" name="min_bet{{i}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.min_bet" id="" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Max Bet:</label>
                                                <input type="number" name="max_bet{{i}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.max_bet" id="" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Max Profit:</label>
                                                <input type="number" name="max_profit{{i}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.max_profit" id="" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Max Market Profit:</label>
                                                <input type="number" name="max_market_profit{{i}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.max_market_profit" id="" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Max Liability:</label>
                                                <input type="number" name="max_liability{{i}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.max_liability" id="" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Max Market Liability:</label>
                                                <input type="number" name="max_market_liability{{i}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.max_market_liability" id="" class="form-control">
                                            </div>
                                        </div>
                        
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <button class="btn btnSubmit" (click)="onSubmit(item, '')">Update</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <app-loader class="full-overlay" *ngIf="submitted"></app-loader>
                            </accordion-group>
                        </accordion>
                        
                        <app-loader class="no-overlay" *ngIf="!data"></app-loader>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>